import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/map/call1.png'


const _withScopeId = (n: any) => (_pushScopeId("data-v-95f3bcd8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "video-pop" }
const _hoisted_2 = { class: "info" }

import Bus from '@/config/Bus'


export default /*#__PURE__*/_defineComponent({
  __name: 'VideoPop',
  props: {
  data: Object,
},
  setup(__props) {

const props = __props

const showCall = () => {
  Bus.emit('showCall', props.data)
}

const close = () => {
  Bus.emit('closePopup')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _renderSlot(_ctx.$slots, "default"),
    _createElementVNode("span", {
      class: "close",
      onClick: close
    }, "×"),
    _createElementVNode("h4", null, _toDisplayString(__props.data.qdmc) + " - " + _toDisplayString(__props.data.zdmc), 1),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", null, _toDisplayString(__props.data.userName) + "：", 1),
      _createElementVNode("span", null, _toDisplayString(__props.data.lxdh), 1)
    ]),
    _createElementVNode("div", { class: "video-tool" }, [
      _createElementVNode("img", {
        src: _imports_0,
        onClick: showCall
      })
    ])
  ]))
}
}

})